import { createSlice } from "@reduxjs/toolkit";
import { getCollaction } from "../../reduxApi/admin/CollactionReduxApi";

const CollactionSlice = createSlice({
  name: "collaction",
  initialState: {
    status: "idle",
    collactions: [],
    error: null,
  },
  reducers: {
    deleteCollectionAction: (state, action) => {
      // const id = action.payload;
      // console.log("hy", action.payload)
      // // console.log("hy2", item?.categories)

      // const index = state.collactions.findIndex((item) => item?.categories?.ROWID === id);
      // if (index !== -1) {
      //   state.collactions.splice(index, 1);
      // }s
      state.collactions = state.collactions.filter(item => !action.payload.includes(item?.categories?.ROWID));
    },

    updateCollectionAction: (state, action) => {
      console.log("action.payload", action.payload)
      const index = state.collactions.findIndex((item) => item.categories.rowId === action.payload.rowId)
      console.log("idex", index)
      if (index != -1) {
        state.collactions.splice(index, 1, { categories: action.payload })
      }
    },
    addCollectionAction: (state, action) => {
      console.log("Adding collection:", action.payload);
      const temp = action.payload.formData;
      temp.ROWID = action.payload.ROWID
      state.collactions.unshift({ categories: temp });
    }
  }
  ,
  extraReducers: (builder) => {
    builder
      .addCase(getCollaction.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getCollaction.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // state.collactions = action.payload.response;
        console.log("action payload ccc", action.payload)
        state.collactions = Array.isArray(action.payload) ? action.payload : [];
        console.log("state.collactionsssssssssssss", state.collactions)
      })
      .addCase(getCollaction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch products";
      });
  },
});
export const { addCollectionAction, deleteCollectionAction, updateCollectionAction } = CollactionSlice.actions

export default CollactionSlice.reducer;
